import { useState } from 'react';
import { Loader2, KeyRound } from 'lucide-react';
import { Button, CopyWrapper } from '@/components/ui';
import mobileAppsIllustration from '@/assets/images/ilustration/mobile-apps-bro-flying.svg';

const ACCESS_CODE_FIXED = 'PLUMAA-FITFOLIO-A081NDL';

interface BenefitRedeemModalProps {
	title: string;
	description: string | null;
	origin: Services.Origin;
}

export const BenefitRedeemModal = ({
	title,
	description,
	origin,
}: BenefitRedeemModalProps) => {
	const [isLoading, setIsLoading] = useState(false);
	const [generatedCode, setGeneratedCode] = useState<string | null>(null);

	const accessLabel =
		origin === 'EXTERNAL'
			? 'acesso à app (externo)'
			: 'acesso à app (interno)';

	const handleGenerateCode = () => {
		setIsLoading(true);
		setGeneratedCode(null);
		setTimeout(() => {
			setGeneratedCode(ACCESS_CODE_FIXED);
			setIsLoading(false);
		}, 1500);
	};

	return (
		<div className="flex flex-col items-center gap-8 text-left md:flex-row md:gap-10">
			<div className="flex shrink-0 justify-center md:w-52 lg:w-60">
				<img
					src={mobileAppsIllustration}
					alt="Ilustração de um personagem voando com aplicativos de celular"
					className="h-auto w-full max-w-[180px] object-contain md:max-w-none"
				/>
			</div>
			<div className="items-left flex flex-1 flex-col gap-6">
				<div className="space-y-2">
					<h2 className="text-xl font-bold tracking-tight text-slate-900 md:text-2xl">
						{title}
					</h2>
					<p className="text-sm leading-relaxed text-slate-500">
						Benefício: {accessLabel}
					</p>
					{description && (
						<p className="text-sm leading-relaxed text-slate-600">
							{description}
						</p>
					)}
				</div>
				<div className="items-left flex w-full max-w-sm flex-col gap-4">
					{!generatedCode ? (
						<Button
							type="button"
							text={
								isLoading
									? 'Gerando...'
									: 'Gerar código de acesso'
							}
							startIcon={
								isLoading ? (
									<Loader2 className="h-4 w-4 animate-spin" />
								) : (
									<KeyRound className="h-4 w-4" />
								)
							}
							onClick={handleGenerateCode}
							disabled={isLoading}
							className="hover:bg-brand-orange/92 inline-flex w-fit shrink-0 rounded-xl border-2 border-brand-orange bg-brand-orange px-6 py-2.5 text-sm font-semibold text-white shadow-sm transition-all disabled:opacity-70"
						/>
					) : (
						<div className="w-full max-w-sm rounded-2xl border border-slate-200 bg-slate-50/80 p-4">
							<p className="mb-2 text-xs font-semibold uppercase tracking-wider text-slate-500">
								Código de acesso
							</p>
							<CopyWrapper
								valueToCopy={generatedCode}
								wrapperClassName="block"
								buttonClassName="!right-3 !top-1/2"
							>
								<input
									type="text"
									readOnly
									value={generatedCode}
									className="h-12 w-full rounded-xl border border-slate-200 bg-white px-4 pr-14 font-mono text-base font-medium text-slate-800 shadow-sm"
								/>
							</CopyWrapper>
						</div>
					)}
				</div>
			</div>
		</div>
	);
};
